export const baseUrl = "https://palwebsite.onrender.com";
